import styled from 'styled-components';
import tw from 'tailwind.macro';

export const Services = styled.div`
  ${tw`flex flex-wrap -mx-3`};
`;

export const ServiceItem = styled.div`
  ${tw`w-full sm:w-1/2`};
`;